/**
 * Cross-feature coordination for the mutually-exclusive right-side panels (to-dos, the split
 * channel, call rooms and the org library). Lives in the foundation service-bus lib so feature libs
 * can publish/subscribe without depending on each other.
 */
export enum RightPanelBusEvents {
  /** Published whenever a right-side panel is opened, so the other panels can close themselves. */
  RightPanelOpened = 'right-panel:opened',
}

/** Which right-side panel was opened. */
export type RightPanel = 'todos' | 'split-channel' | 'call-rooms' | 'org-library';

export interface RightPanelBusEventPayloads {
  [RightPanelBusEvents.RightPanelOpened]: RightPanel;
}
